import { categories } from '@/mocks/articles';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-hide">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}